import { Copy16 } from "@carbon/icons-react"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"
import React from "react"
import CopyButton from "../molecules/CopyButton"

const ProductData = ({ keyValueItems, nestedKeyValueItems, title }) => {
  if (keyValueItems?.length === 0 && nestedKeyValueItems?.length === 0)
    return null
  return (
    <div className={title ? "py-8 px-6" : ""}>
      {title && (
        <Headline
          headline={title}
          headlineLevel="h3"
          tagName="h4"
          className="pb-4"
        />
      )}
      <>
        {keyValueItems && (
          <div className="pt-4 border-t-2 border-gray-200">
            {keyValueItems.map((item) => (
              <div
                className="flex px-4 py-2 even:bg-gray-100"
                key={item.originId}
                data-product-attr-id={item.originId}
              >
                <label className="w-1/2 py-2 font-light text-left lg:w-1/3">
                  {item.label}
                </label>
                <div className="flex flex-row justify-between w-1/2 py-2 lg:w-2/3">
                  {item.value}
                  {(item.originId === "8319" || item.originId === "8935") && (
                    <CopyButton
                      className="px-2 py-1 text-primary hover:text-primary-hover"
                      copiedData={item.value}
                    >
                      <Copy16 />
                    </CopyButton>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </>
      {nestedKeyValueItems && (
        <>
          {nestedKeyValueItems.map((item) => (
            <div
              className="flex px-4 py-4 border-t-2 border-gray-200"
              key={item.originId}
              data-product-attr-id={item.originId}
            >
              <label className="w-1/2 py-2 font-light text-left lg:w-1/3">
                {item.label}
              </label>

              <div className="w-1/2 lg:w-2/3">
                <ul className="list-disc">
                  {item.items?.map((c, innerindex) => (
                    <li className="py-2" key={innerindex}>
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  )
}

export default ProductData
